import React, { memo } from "react";
import { Row, Col } from "react-bootstrap";
import { Field } from "redux-form";

import RadioButton from "components/radioButton";

const AchDepositBlock = () => (
	<>
		<Row className="mb-3">
			<Col md={5}>
				<Row>
					<Col>
						<Field
							component={RadioButton}
							type="radio"
							name="discountType"
							label="Individual / Deposit"
							id="individualDeposit"
							value="0"
						/>
					</Col>
					<Col>
						<Field
							component={RadioButton}
							type="radio"
							name="discountType"
							label="Combined"
							id="combinedDeposit"
							value="1"
						/>
					</Col>
				</Row>
			</Col>
		</Row>
		<Row className="mb-5">
			<Col md={5}>
				<Row>
					<Col>
						<Field
							component={RadioButton}
							type="radio"
							name="isMonthEnd"
							label="Month End Discount"
							id="monthEndDiscount"
							value="true"
						/>
					</Col>
					<Col>
						<Field
							component={RadioButton}
							type="radio"
							name="isMonthEnd"
							label="Daily Discount"
							id="dailyDiscount"
							value="false"
						/>
					</Col>
				</Row>
			</Col>
		</Row>
	</>
);

export default memo(AchDepositBlock);
